import Product from "../models/Product";

export class ProductRepository {

    static products: Product[] = [];

    static getProduct(id: number): Product {
        const searchResult = this.products.find((product) => product.id === id);
        if (searchResult) {
            return searchResult;
        }
        return {
            id: id,
            title: `${id}`
        };
    }

    static async fetchProducts(isInitialOnly: boolean = true) {
        if(isInitialOnly && this.products.length>= 1){
            return;
        }
        
        let prefix = '';
        if (window.location.hostname === 'localhost') {
            prefix = 'http://localhost/osica-member';
        } else {
            prefix = '/member';
        }

        const url = prefix + `/api/cardapi/product-list`;

        try {
            const result = await fetch(url);
            if (result.ok) {
                const json = await result.json();
                if (Array.isArray(json)) {
                    this.products = json;
                    //console.log('Ready products.', this.products);
                }
            } else {
                throw new Error(`Return status code ${result.status}.`);
            }
        } catch (error) {
            console.log("Failed fetch product list.", error);
        }
    }
}